import { SaveBlocker, DefaultTemplate } from '@bingads-webui-react/wizard-ui-library';
import { ConfigureStudyStep } from '../common/components/configure-study-step';
import { useConfigureStudyRepository } from '../common/components/configure-study-step-repository';
import { SelectCampaignsStep } from '../common/components/select-campaigns-step';
import { useSelectCampaignsRepository } from '../common/components/select-campaigns-step-repository';

export const stepConfigs = [{
  id: 'step-1',
  view: SelectCampaignsStep,
  repository: useSelectCampaignsRepository,
}, {
  id: 'step-2',
  view: ConfigureStudyStep,
  repository: useConfigureStudyRepository,
}];

export const layoutConfig = {
  'step-1': {
    template: DefaultTemplate,
    noBlocker: true,
  },
  'step-2': {
    template: DefaultTemplate,
    customBlocker: SaveBlocker,
  },
};
